import Voting, {transformDate, IVotingDTO} from './base';
import config from 'config';
import {utility} from '../../utilites/index';
import {LiveImage, LiveImageDTO} from "../image";

export class BingoVotingImageDTO extends LiveImageDTO {
  large: string;
}

export class BingoVotingImage extends LiveImage {
  protected _large: string;

  get large(): string {
    return this.isSaved ? this._large : this.url;
  }

  get preview(): string {
    return this.large;
  }

  constructor(data: BingoVotingImageDTO) {
    super(data);
    this._large = data.large;
  }
}

export interface IBingoVotingDTO extends IVotingDTO{
  award: {
    description: string;
    location: string;
    image: BingoVotingImageDTO;
    expiration_time: number;
    game_description: string;
  };
}

export default class BingoVoting extends Voting {
  game_description: string;
  award_location: string;
  file: LiveImage;

  static path = `${config.backOfficeBasePath}/votings/bingo`;

  static validateConstraints = Object.assign({}, Voting.validateConstraints, {
    file: { presence: {message: '^Please upload an image'} },
    award_location: { presence: {message: '^Pick-up location is missing'}}
  });

  static listAction(eventId, query = {}, perPage = 500, page = 0) {
    query = Object.assign({}, query, {
      page,
      perPage
    });

    return utility.networkLayer.getJson(this.path.replace(':eventId', eventId), query)
      .then(data => this.mapRecords(data));
  }

  static mapRecords(data) {
    return data.map((item) => new BingoVoting(item));
  }

  _getModel() {
    return BingoVoting;
  }

  get _createUrl() {
    return `${config.backOfficeBasePath}/events/:eventId/votings/bingo`.replace(':eventId', this.eventId);
  }

  get _publishUrl() {
    return `${config.backOfficeBasePath}/votings/bingo/:votingId/publish`.replace(':votingId', this.id);
  }

  protected async _createRecord(dataForSave) {
    let res = await this._networkLayer.postFormData(this._createUrl, dataForSave);
    return await res.json();
  }

  protected async _updateRecord(dataForSave) {
    let res = await this._networkLayer.putFormData(this._prepareUrl(this.id), dataForSave);
    return await res.json();
  }

  prepareForSave() {
    let { award_location, file, game_description } = this;
    let data: any = Object.assign(super.prepareForSave(), {
      award_location,
      game_description,
    });

    if (file && file instanceof LiveImage) {
      data.file = file.file;
    }

    return data;
  }

  _parseData(data: IBingoVotingDTO) {
    let res: any = {};
    // console.log(data.award, 87897987)
    if (data.award !== undefined) {
      res.award_location = data.award.location;
      res.game_description = data.award.game_description;
      // if (data.award.game_description) {
      //   res.game_description = new BingoVotingImage(Object.assign(new BingoVotingImageDTO(), data.award.game_description));
      // }
      if (data.award.image) {
        res.award_image = new BingoVotingImage(Object.assign(new BingoVotingImageDTO(), data.award.image));
      }
      delete data.award;
    }

    return Object.assign(res, super._parseData(data));
  }
}




// WEBPACK FOOTER //
// ./src/api/voting/bingo.ts